import classnames from 'classnames';
import React, { useState } from 'react';
import { StyledPasswordInput, StyledShowPasswordButton } from './styleds';

export const RawPasswordInput = ({
  viewer = true,
  type = 'text',
  isInt = false,
  inputRef,
  ...props
}) => {
  const [show, setShow] = useState(false);

  const onClickViewPassword = () => {
    setShow(!show);
  };

  return (
    <React.Fragment>
      <div
        className="d-flex flex-row"
        style={{ margin: '0 0 0 0', padding: '0 0 0 0' }}
      >
        <StyledPasswordInput
          {...props}
          id={props.name}
          type={type}
          show={show}
          ref={inputRef}
          onKeyDown={(evt) => {
            if (type === 'number' && isInt) {
              if (
                evt.key === 'e' ||
                evt.key === 'E' ||
                evt.key === '.' ||
                evt.key === '+' ||
                evt.key === '-'
              ) {
                evt.preventDefault();
              }
            }
          }}
        />
        {viewer && (
          <StyledShowPasswordButton onClick={onClickViewPassword} type="button">
            <i
              className={classnames({
                'pi pi-eye': !show,
                'pi pi-eye-slash': show,
              })}
            />
          </StyledShowPasswordButton>
        )}
      </div>
    </React.Fragment>
  );
};

export const RawMaskInput = () => {
  return <React.Fragment></React.Fragment>;
};
